import { inject, Injectable } from '@angular/core';
import { interval, switchMap } from 'rxjs';
import { BasePollingService } from '../../../core/services/base-polling.service';
import { RuntimeConfigService } from '../../../core/services/runtime-config.service';
import { DbLatestTransactionsComponent } from '../../components/dashboard/custom-views/db-latest-transactions/db-latest-transactions.component';
import { TransactionData } from '../../interfaces/transaction/transaction-data';
import { TransactionDataService } from '../transaction-data.service';

@Injectable({
  providedIn: 'root'
})
export class LatestTransactionsPollingService extends BasePollingService {

  dataService = inject(TransactionDataService);
  pollingInterval: number = inject(RuntimeConfigService).transactionDataPollingInterval;

  subscribePolling(component: DbLatestTransactionsComponent) {
    this.pollingSubscription = interval(this.pollingInterval)
    .pipe(switchMap(() => this.dataService.getLatestTransactions(component.transactionQueryConfig)))
    .subscribe({
      next: (response) => {
        if (response.successful) {
         const newTransactionData: TransactionData[] = response.payload;
         if (this.helper.dataArrayHash(newTransactionData) !== component.lastDataHash) {
           component.getLatestTransactions();
         }
        }
      },
      error: (err) => {
        console.error('Error on Transaction-Polling:', err);
      },
    });
    this.isSubscribed = true;
  }

}
